import React, { useState } from 'react';
import { useNavigate, Link as RouterLink } from 'react-router-dom';
import packageJson from '../../package.json';
import {
  Box,
  Button,
  Card,
  CardContent,
  TextField,
  Typography,
  Alert,
  Link,
} from '@mui/material';
import { useAuth } from '../context/AuthContext';

export default function LoginPage() {
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const { login } = useAuth();
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    try {
      await login(username, password);
      navigate('/admin/dashboard');
    } catch (err) {
      setError(err.message || 'Login failed');
    }
  };

  return (
    <Box
      sx={{
        minHeight: '100vh',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        background: 'linear-gradient(135deg, #1a237e 0%, #283593 50%, #3949ab 100%)',
      }}
    >
      <Card sx={{ maxWidth: 400, width: '100%', mx: 2 }}>
        <CardContent sx={{ p: 4 }}>
          <Box
            component="img"
            src={`${process.env.PUBLIC_URL || ''}/wh-logo.png`}
            alt="Walter Hill Church of Christ"
            sx={{ height: 56, display: 'block', mx: 'auto', mb: 2 }}
          />
          <Typography variant="h4" gutterBottom textAlign="center" color="primary">
            Church Portal
          </Typography>
          <Typography variant="subtitle1" gutterBottom textAlign="center" color="text.secondary">
            Admin Portal
          </Typography>
          <Box component="form" onSubmit={handleSubmit} sx={{ mt: 3 }}>
            {error && (
              <Alert severity="error" sx={{ mb: 2 }}>
                {error}
              </Alert>
            )}
            <TextField
              fullWidth
              label="Username"
              value={username}
              onChange={(e) => setUsername(e.target.value)}
              margin="normal"
              required
              autoFocus
            />
            <TextField
              fullWidth
              label="Password"
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              margin="normal"
              required
            />
            <Button
              type="submit"
              fullWidth
              variant="contained"
              size="large"
              sx={{ mt: 3 }}
            >
              Sign In
            </Button>
            <Box sx={{ mt: 2, textAlign: 'center' }}>
              <Link component={RouterLink} to="/forgot-password" variant="body2" underline="hover">
                Forgot Password?
              </Link>
            </Box>
          </Box>
          <Typography
            variant="caption"
            component="div"
            color="text.secondary"
            textAlign="center"
            sx={{ mt: 3, opacity: 0.8 }}
          >
            v{packageJson.version}
          </Typography>
        </CardContent>
      </Card>
    </Box>
  );
}
